import { Box, Typography, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Iconify from "./Iconify";
import { PATH_BRANDS } from "~src/routes/paths";

export default function BrandNotFound() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        px: 3,
      }}
    >
      {/* Space-themed animated rocket */}
      <Box
        sx={{
          width: 120,
          height: 120,
          mb: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        <Box
          component="div"
          sx={{
            width: 80,
            height: 80,
            animation: 'float 3s ease-in-out infinite',
            '@keyframes float': {
              '0%, 100%': {
                transform: 'translateY(0px) rotate(0deg)',
              },
              '50%': {
                transform: 'translateY(-10px) rotate(5deg)',
              },
            },
          }}
        >
          <Iconify
            icon="game-icons:rocket"
            sx={{
              width: '100%',
              height: '100%',
              color: 'primary.main',
              filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))',
            }}
          />
        </Box>
        {/* Animated stars around the rocket */}
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            animation: 'twinkle 2s ease-in-out infinite alternate',
            '@keyframes twinkle': {
              '0%': { opacity: 0.3 },
              '100%': { opacity: 1 },
            },
          }}
        >
          <Iconify
            icon="mdi:star"
            sx={{
              position: 'absolute',
              top: '10%',
              right: '20%',
              width: 12,
              height: 12,
              color: 'warning.main',
            }}
          />
          <Iconify
            icon="mdi:star"
            sx={{
              position: 'absolute',
              bottom: '15%',
              left: '15%',
              width: 8,
              height: 8,
              color: 'info.main',
            }}
          />
          <Iconify
            icon="mdi:star"
            sx={{
              position: 'absolute',
              top: '25%',
              left: '10%',
              width: 10,
              height: 10,
              color: 'secondary.main',
            }}
          />
        </Box>
      </Box>
      
      <Typography variant="h4" sx={{ mb: 2 }}>
        Lost in Space
      </Typography>
      
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400 }}>
        This brand has drifted off into the cosmos. It may have been removed or the link may be incorrect.
      </Typography>
      
      <Stack direction="row" spacing={2}>
        <Button
          variant="contained"
          startIcon={<Iconify icon="mdi:arrow-left" />}
          onClick={() => navigate(-1)}
        >
          Go Back
        </Button>
        
        <Button
          variant="outlined"
          startIcon={<Iconify icon="mdi:trending-up" />}
          onClick={() => navigate(PATH_BRANDS.trending)}
        >
          Browse Trending Brands
        </Button>
      </Stack>
    </Box>
  );
} 